import { Defaults } from "./defaults";
$(() => {
    Defaults.init();
});
window.login = ({ data: { token } }) => {
    $.ajax({
        api: false,
        url: 'ajax/save-token.php',
        method: 'POST',
        data: { token },
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        processData: true,
        error: () => null,
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).done(({ data: { redirect } }) => {
        location.href = redirect || './';
    }).fail(Defaults.handleAjaxError);
};
import "expose-loader?exposes[]=JSZip!jszip";
import "expose-loader?exposes[]=App!./modules/app";
